import useLoad from 'components/hooks/useLoad';
import {choice} from 'constants/url';

function useLoadChoices(idCourse: number, idContent: number) {
  return useLoad(choice, 'iD_Choice', {idCourse, idContent});
}

export default useLoadChoices;
